import { CircularProgress } from '@mui/material';

const ButtonLoadingIcon = () => <CircularProgress size={18} sx={{ color: 'inherit' }} />;

export default ButtonLoadingIcon;
